import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { useAuthStore } from '../store';

// Solo CEO: abre el portal del cliente en modo solo lectura
export function ViewClientPortalButton({ clientId }) {
  const navigate = useNavigate();
  const viewClientPortal = useAuthStore((s) => s.viewClientPortal);
  const [busy, setBusy] = useState(false);
  const open = async () => {
    setBusy(true);
    try {
      await viewClientPortal(clientId);
      navigate('/client-portal/welcome');
    } catch (e) {
      toast.error(e.message);
    } finally {
      setBusy(false);
    }
  };
  return (
    <Button variant="outline" onClick={open} disabled={busy} data-testid="view-client-portal-btn">
      {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Eye className="w-4 h-4 mr-2" />}
      Ver su portal
    </Button>
  );
}
